import { cva, type VariantProps } from "class-variance-authority";

// `segment` — переключатель в общей рамке, `pill` — отдельные «таблетки» с переносом строк.
export const toggleGroupVariants = cva("group/toggle-group", {
  variants: {
    variant: {
      segment: "inline-flex gap-0.5 rounded-lg border border-border bg-background p-[3px]",
      pill: "flex flex-wrap gap-1",
    },
  },
  defaultVariants: {
    variant: "segment",
  },
});

export type ToggleGroupVariantProps = VariantProps<typeof toggleGroupVariants>;
